import { render, staticRenderFns } from "./mingtang.vue?vue&type=template&id=4c1096ef&scoped=true&"
import script from "./mingtang.vue?vue&type=script&lang=js&"
export * from "./mingtang.vue?vue&type=script&lang=js&"
import style0 from "./mingtang.vue?vue&type=style&index=0&id=4c1096ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1096ef",
  null
  
)

export default component.exports